import { strCode } from "../../../../../consts";

export const metricsConfig = {
  received: {
    id: "received",
    name: strCode.RECEIVED_LABEL,
    color: "#2BBA99"
  },

  waitingResponse: {
    id: "waitingResponse",
    name: strCode.WAITING_RESPONSE_LABEL,
    color: "#D6D6D8"
  }
};
